exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-f0574da4]{background-color:#F5F4E8 !important\n}\n.btn-primary.disabled[data-v-f0574da4],.btn-primary[data-v-f0574da4]:disabled{color:#fff;background-color:#00c8f8 !important;border-color:#00c8f8 !important;opacity:1.00 !important\n}\n.btn-primary.disabled[data-v-f0574da4]:hover,.btn-primary[data-v-f0574da4]:disabled:hover{color:#fff;background-color:#879649 !important;border-color:#879649 !important;opacity:1.00 !important\n}\n.ResetPassword[data-v-f0574da4]{width:160px !important;margin-left:auto !important;margin-right:auto !important;font-weight:bold !important\n}\n", ""]);

// exports
